/** @graphql cc **/

import gql from 'graphql-tag';

// When modifying any fragment (ConfluencePage, ConfluenceBlogPost, ConfluenceWhiteboard, etc.), make sure
// to update all instances of that fragment used in this query. Otherwise, useQuery will return undefined and break the experience.
// Fragment spreads will be reintroduced via Relay: https://hello.atlassian.net/wiki/spaces/UIP/blog/2024/10/21/4166388009/GraphQL+Codemods+and+U+IP
export const RecentContentMenuQuery = gql`
	query RecentContentMenuQuery(
		$cloudId: ID!
		$first: Int
		$after: String
		$eventTypes: [String!]
		$objectTypes: [String!]
	) {
		activity {
			myActivity {
				all(
					filter: {
						type: AND
						rootContainerIds: [$cloudId]
						arguments: {
							products: ["CONFLUENCE"]
							objectTypes: $objectTypes
							eventTypes: $eventTypes
						}
					}
					first: $first
					after: $after
				) {
					edges {
						cursor
						node {
							id
							object {
								id
								data {
									... on ConfluencePage {
										id
										title
										type
										subtype
										pageStatus: status
										createdAt
										links {
											webUi
											editUi
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										space {
											id
											alias
											key
											name
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
									}
									... on ConfluenceBlogPost {
										id
										title
										type
										blogStatus: status
										createdAt
										links {
											webUi
											editUi
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										space {
											id
											alias
											key
											name
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
									}
									... on ConfluenceWhiteboard {
										id
										title
										type
										status
										links {
											webUi
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										space {
											id
											alias
											key
											name
										}
									}
									... on ConfluenceDatabase {
										id
										title
										type
										status
										links {
											webUi
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										space {
											id
											alias
											key
											name
										}
									}
									... on ConfluenceEmbed {
										id
										title
										type
										status
										links {
											webUi
										}
										viewer {
											favoritedSummary {
												isFavorite
											}
										}
										space {
											id
											alias
											key
											name
										}
										metadata {
											titleEmojiDraft {
												value
											}
											titleEmojiPublished {
												value
											}
										}
									}
									... on ConfluenceInlineComment {
										id
										commentId
										container {
											... on ConfluencePage {
												id
												title
												type
												subtype
												pageStatus: status
												createdAt
												links {
													webUi
													editUi
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												space {
													id
													alias
													key
													name
												}
												metadata {
													titleEmojiDraft {
														value
													}
													titleEmojiPublished {
														value
													}
												}
											}
											... on ConfluenceBlogPost {
												id
												title
												type
												blogStatus: status
												createdAt
												links {
													webUi
													editUi
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												space {
													id
													alias
													key
													name
												}
												metadata {
													titleEmojiDraft {
														value
													}
													titleEmojiPublished {
														value
													}
												}
											}
											... on ConfluenceWhiteboard {
												id
												title
												type
												status
												links {
													webUi
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												space {
													id
													alias
													key
													name
												}
											}
										}
									}
									... on ConfluenceFooterComment {
										id
										commentId
										container {
											... on ConfluencePage {
												id
												title
												type
												subtype
												pageStatus: status
												createdAt
												links {
													webUi
													editUi
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												space {
													id
													alias
													key
													name
												}
												metadata {
													titleEmojiDraft {
														value
													}
													titleEmojiPublished {
														value
													}
												}
											}
											... on ConfluenceBlogPost {
												id
												title
												type
												blogStatus: status
												createdAt
												links {
													webUi
													editUi
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												space {
													id
													alias
													key
													name
												}
												metadata {
													titleEmojiDraft {
														value
													}
													titleEmojiPublished {
														value
													}
												}
											}
											... on ConfluenceWhiteboard {
												id
												title
												type
												status
												links {
													webUi
												}
												viewer {
													favoritedSummary {
														isFavorite
													}
												}
												space {
													id
													alias
													key
													name
												}
											}
										}
									}
								}
							}
							event {
								timestamp
								eventType
							}
						}
					}
					pageInfo {
						hasNextPage
						endCursor
					}
				}
			}
		}
	}
`;

export const RecentlyCreatedByMeQuery = gql`
	query RecentlyCreatedByMeQuery($cql: String!, $cqlcontext: String!, $first: Int, $after: String) {
		search: confluence_search(cql: $cql, cqlcontext: $cqlcontext, first: $first, after: $after) {
			nodes {
				url
				content {
					id
					type
					subType
					title
					status
					space {
						id
						name
					}
					links {
						webui
						editui
					}
					metadata {
						currentuser {
							favourited {
								isFavourite
								favouritedDate
							}
							lastcontributed {
								status
								when
							}
						}
					}
					emoji: properties(keys: ["emoji-title-published", "emoji-title-draft"]) {
						nodes {
							id
							key
							value
						}
					}
					space {
						alias
					}
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;
